module.exports = __webpack_public_path__ + "img/reloj.5e1cfd1a.svg";